import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import {settingsApi} from '../http/Api';

export const getSettings = createAsyncThunk('Settings/getSettings', async (_, thunkAPI) => {
  const {serverId} = thunkAPI.getState().serverId;
  const response = await settingsApi.getSettings(serverId);
  console.log('response', response);

  if (response.status === 200) {
    thunkAPI.dispatch(settingsSlice.actions.setSettings(response));
  }
});

const initialState = {
  settingsState: null,
};

const settingsSlice = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettings: (state, action) => {
      state.settingsState = action.payload;
    },
  },
});

export const settings = settingsSlice.reducer;
